export const BrandEnum = Object.freeze({
  LAMINA_SC: 13,
});
